import React from "react";
import { graphql, PreloadedQuery, usePreloadedQuery } from "react-relay";
import { WidgetRoutineOverviewDataComponent } from "widgets/src/WidgetRoutineOverview/WidgetRoutineOverview";
import { WidgetChecklistOverviewPreviewQuery } from "./__generated__/WidgetChecklistOverviewPreviewQuery.graphql";

type Props = {
  storecastId: string;
  query: PreloadedQuery<WidgetChecklistOverviewPreviewQuery>;
};

export const WIDGET_CHECKLIST_OVERVIEW_PREVEW_QUERY = graphql`
  query WidgetChecklistOverviewPreviewQuery(
    $storecastId: ID!
    $input: PreviewWidgetRoutineOverviewInput!
  ) {
    dashboard(id: $storecastId) @required(action: THROW) {
      previewWidgetRoutineOverview(input: $input) {
        ...WidgetRoutineOverviewDataComponent_widgetRoutineOverview
      }
    }
  }
`;
export function WidgetChecklistOverviewPreview(props: Props) {
  const data = usePreloadedQuery<WidgetChecklistOverviewPreviewQuery>(
    WIDGET_CHECKLIST_OVERVIEW_PREVEW_QUERY,
    props.query
  );

  return (
    <WidgetRoutineOverviewDataComponent
      mode="IDLE"
      interactive={false}
      widget={data.dashboard.previewWidgetRoutineOverview}
      storecastId={props.storecastId}
    />
  );
}
